import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import * as moment from 'moment';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { MessageService } from 'src/app/modules/shared/services/message.service';

@Component({
  selector: 'app-create-coupon',
  templateUrl: './create-coupon.component.html',
  styleUrls: ['./create-coupon.component.scss']
})
export class CreateCouponComponent implements OnInit {

  public loginData: any;
  public retailerData: any;
  public couponData: any;

  public couponCreationStep: number;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _messageService: MessageService
  ) { }

  async ngOnInit() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');
    this.retailerData = await this._utilService.getStorageData('R_RETAILERS');

    // Set to step 1
    this.couponCreationStep = 1;
    let responseRemoveStorageDataC_NEW_COUPON = await this._utilService.removeStorageData('R_NEW_COUPON'); // Remove storage if exists

    // Set new coupon storage data with store details (NOT USED NOW - STORE ADDING IS ON LAST STEP NOW)
    /*if (this.retailerData.length > 0 ) {
      this.couponData = {
        retailers: []
      }

      let selectedeRtailerDetails : any = {
        retailer_id: this.retailerData[0].retailer_id,
        retailer_name: this.retailerData[0].retailer_name,
        logo: this.retailerData[0].logo,
        stores: []
      };

      for (let i=0; i  <= this.retailerData.length - 1; i++) {
        selectedRetailerDetails.stores.push({
          status:  true, // Select by default
          store_id:  this.retailerData[i].store_id,
          store_name: this.retailerData[i].store_name,
          date_range: [new Date(moment.utc().format('YYYY-MM-DD')), new Date(moment.utc().add(30, 'days').format('YYYY-MM-DD'))],
          max_redeem_quantity: 1, // Default
          max_redemptions: 0, // Default
        });
      }

      this.couponData.retailers.push(selectedRetailerDetails);

      let responseSetStorageDataR_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
    } else {
      let responseRemoveStorageDataR_NEW_COUPON = await this._utilService.removeStorageData('R_NEW_COUPON'); // Remove storage if exists
      this._utilService.showToast('Store details not found', '', 'error', {});
    }*/
  }

  // On step selection
  async onStepSelection(event: any) {
    //console.log(event);
  }

  // On navigation click
  async onNavigationClick(event: any) {
    this._messageService.sendMessage({id: 'message-updatePreview', step: event.step});

    switch(event.step) {
      case 1: { // Step 1
        if (event.button == 'next') {
          this.couponCreationStep = 2;
        }
        break;
      } case 2: { // Step 2
        if (event.button == 'next') {
          this.couponCreationStep = 3;
        } else {
          this.couponCreationStep = 1;
        }
        break;
      } case 3: { // Step 3
        if (event.button == 'previous') {
          this.couponCreationStep = 2;
        } else if (event.button == 'submit') {
          this._utilService.showToast('Coupon created successfully', '', 'success', {});
          this._router.navigate(['/retailer/coupons']); // Go to coupons
        }
        break;
      }
    }
  }

}
